export enum OrderStatusEnum {
    New = 1,
    InProcessing,
    Done,
}